/*
 * ws-email-typo.js — メールアドレスのドメイン打ち間違いを見つけて「もしかして」を出す(2026-10-19)
 *
 * - 対象: input[type=email] と、name / id / autocomplete に email を含む入力欄(後から追加される欄も対象)
 * - 判定: 入力欄からフォーカスが外れたとき・フォーム送信時。送信は止めない
 * - 候補をクリックするとその場で書き換える。「×」でその値については出さない
 * - 打ち間違いの表:
 *     1) TYPO_DOMAINS … 正本 winds-newsletter/gas/Shopify.gs をそのまま写したもの
 *     2) 追加分 … 主要ドメインから編集距離1の変種を機械生成し、dig MX で受信設定が
 *        「ある」または判定できなかったもの(EXCLUDE)を除いたもの。
 *        実在ドメイン(SAFE)や、2つの正しいドメインのどちらの間違いか曖昧なものは出さない
 *     3) ドメインに「.」が無い(例: taro@gmail)場合の補完
 * - 作業場: ~/Code/Claude/windsscore-theme-fixes/2026-10-19-email-typo/(ビルド: build_js.py)
 * - 個別に止めたい欄は祖先に data-ws-email-typo="off" を付ける
 */
(function () {
  'use strict';
  if (window.__wsEmailTypo) return;
  window.__wsEmailTypo = true;

  /* 1) 正本(Shopify.gs の TYPO_DOMAINS)。⚠ yahoo.ne.jp は Y!mobile の実在ドメインなので入れない */
  var TYPO_DOMAINS = {"gmai.com":"gmail.com","gmil.com":"gmail.com","gmal.com":"gmail.com","gamil.com":"gmail.com","gmial.com":"gmail.com","gnail.com":"gmail.com","gmaill.com":"gmail.com","gmail.co":"gmail.com","gmail.con":"gmail.com","gmail.cm":"gmail.com","gmail.om":"gmail.com","gmail.cpm":"gmail.com","gmail.comm":"gmail.com","gmail.jp":"gmail.com","gmail.co.jp":"gmail.com","gmail.ne.jp":"gmail.com","icioud.com":"icloud.com","iclod.com":"icloud.com","icould.com":"icloud.com","icluod.com":"icloud.com","iclud.com":"icloud.com","icoud.com":"icloud.com","iclound.com":"icloud.com","icloud.co":"icloud.com","icloud.con":"icloud.com","icloud.cm":"icloud.com","icloud.jp":"icloud.com","icloud.comm":"icloud.com","yahoo.co.jpp":"yahoo.co.jp","yaho.co.jp":"yahoo.co.jp","yahooo.co.jp":"yahoo.co.jp","yahoo.co.jo":"yahoo.co.jp","yahoo.cp.jp":"yahoo.co.jp","yhoo.co.jp":"yahoo.co.jp","docomo.ne.jo":"docomo.ne.jp","docomo.ne.jpp":"docomo.ne.jp","docomo.co.jp":"docomo.ne.jp","docom.ne.jp":"docomo.ne.jp","docomo.ne":"docomo.ne.jp","docomo.jp":"docomo.ne.jp","ezweb.ne.jo":"ezweb.ne.jp","ezweb.ne.jpp":"ezweb.ne.jp","ezweb.co.jp":"ezweb.ne.jp","ezwed.ne.jp":"ezweb.ne.jp","ezweb.ne":"ezweb.ne.jp","ezweb.jp":"ezweb.ne.jp","i.softbank.jo":"i.softbank.jp","i.sofbank.jp":"i.softbank.jp","i.softbank.ne.jp":"i.softbank.jp","hotmai.com":"hotmail.com","hotmal.com":"hotmail.com","hotmail.con":"hotmail.com","outlok.com":"outlook.com","outlook.con":"outlook.com","ciloud.com":"icloud.com","ggmail.com":"gmail.com","ghmail.com":"gmail.com","gjmail.com":"gmail.com","gkmail.com":"gmail.com","gma8l.com":"gmail.com","gma9il.com":"gmail.com","gma9l.com":"gmail.com","gmaail.com":"gmail.com","gmai8l.com":"gmail.com","gmai9l.com":"gmail.com","gmaiil.com":"gmail.com","gmaijl.com":"gmail.com","gmailk.com":"gmail.com","gmailp.com":"gmail.com","gmaio.com":"gmail.com","gmaiol.com":"gmail.com","gmaip.com":"gmail.com","gmaipl.com":"gmail.com","gmaiul.com":"gmail.com","gmajil.com":"gmail.com","gmajl.com":"gmail.com","gmakil.com":"gmail.com","gmakl.com":"gmail.com","gmaol.com":"gmail.com","gmasil.com":"gmail.com","gmauil.com":"gmail.com","gmjail.com":"gmail.com","gmqail.com":"gmail.com","gmqil.com":"gmail.com","gmsil.com":"gmail.com","gmwil.com":"gmail.com","gmzail.com":"gmail.com","gmzil.com":"gmail.com","gnmail.com":"gmail.com","icl9ud.com":"icloud.com","iclkoud.com":"icloud.com","icllud.com":"icloud.com","iclo0ud.com":"icloud.com","iclo7d.com":"icloud.com","iclo8d.com":"icloud.com","iclo8ud.com":"icloud.com","iclohd.com":"icloud.com","iclojd.com":"icloud.com","iclolud.com":"icloud.com","iclopud.com":"icloud.com","iclou.com":"icloud.com","icloued.com":"icloud.com","iclouid.com":"icloud.com","icloujd.com":"icloud.com","iclourd.com":"icloud.com","iclous.com":"icloud.com","icloux.com":"icloud.com","iclouyd.com":"icloud.com","icoloud.com":"icloud.com","icooud.com":"icloud.com","icpoud.com":"icloud.com","idloud.com":"icloud.com","ifloud.com":"icloud.com","iicloud.com":"icloud.com","ivloud.com":"icloud.com","tgmail.com":"gmail.com","ygmail.com":"gmail.com"};

  /* 2) 追加分の生成元 [正しいドメイン, ラベル固定(TLD側だけ変化)] */
  var TARGETS = [["gmail.com",false],["icloud.com",false],["yahoo.co.jp",false],["docomo.ne.jp",false],["ezweb.ne.jp",false],["au.com",true],["i.softbank.jp",false],["softbank.ne.jp",false],["ymobile.ne.jp",false],["yahoo.ne.jp",false],["hotmail.com",false],["hotmail.co.jp",false],["outlook.com",false],["outlook.jp",false],["live.jp",true],["me.com",true],["nifty.com",false],["biglobe.ne.jp",false],["ocn.ne.jp",true],["ybb.ne.jp",true]];
  /* 打ち間違い扱いしない実在ドメイン(携帯キャリア・プロバイダ・主要フリーメール) */
  var SAFE = ["aol.com","au.com","biglobe.ne.jp","dion.ne.jp","disney.ne.jp","docomo.ne.jp","emobile.ne.jp","eonet.ne.jp","excite.co.jp","ezweb.ne.jp","gmail.com","goo.jp","googlemail.com","hotmail.co.jp","hotmail.com","i.softbank.jp","icloud.com","infoseek.jp","jcom.home.ne.jp","jcom.zaq.ne.jp","kcn.ne.jp","live.com","live.jp","mac.com","mail.goo.ne.jp","me.com","msn.com","nifty.com","ocn.ne.jp","outlook.com","outlook.jp","pdx.ne.jp","plala.or.jp","proton.me","protonmail.com","rakuten.jp","so-net.ne.jp","softbank.jp","softbank.ne.jp","tiki.ne.jp","uqmobile.jp","wcm.ne.jp","willcom.com","yahoo.co.jp","yahoo.com","yahoo.ne.jp","ybb.ne.jp","ymail.com","ymail.ne.jp","ymobile.ne.jp","ymobile1.ne.jp","zoho.com"];
  /* 変種のうち dig MX で受信設定があった/判定できなかったもの(=候補に出さない) */
  var EXCLUDE = "0utlook.com 0utlook.jp 8icloud.com 9cloud.com 9icloud.com 9utlook.com aul.com bhotmail.com bifty.com biglob.ene.jp biglobe.lne.jp biglobe.ne3.jp biglobe.ne4.jp biglobe.ned.jp biglobe.nje.jp bmail.com bnifty.com ciloud.com cloud.com cocomo.ne.jp docomo.lne.jp docomo.ne3.jp docomo.ne4.jp docomo.ned.jp docomo.nje.jp exweb.ne.jp ezweb.lne.jp ezweb.ne3.jp ezweb.ne4.jp ezweb.ned.jp ezweb.nje.jp fmail.com gahoo.co.jp gail.com gbmail.com ggmail.com ghmail.com gjmail.com gkmail.com gma8l.com gma9il.com gma9l.com gmaail.com gmai8l.com gmai9l.com gmaiil.com gmaijl.com gmaikl.com gmailk.com gmailp.com gmaio.com gmaiol.com gmaip.com gmaipl.com gmaiul.com gmajil.com gmajl.com gmakil.com gmakl.com gmaol.com gmasil.com gmauil.com gmazil.com gmjail.com gmqail.com gmqil.com gmsil.com gmwil.com gmzail.com gmzil.com gnmail.com gvmail.com h9otmail.com h9tmail.com hbotmail.com hgmail.com hgotmail.com hktmail.com hlotmail.com hnotmail.com ho5mail.com ho5tmail.com ho6mail.com ho9tmail.com hofmail.com hoftmail.com hoitmail.com holtmail.com hoptmail.com hotfmail.com hotgmail.com hotjmail.com hotkail.com hotma8il.com hotma8l.com hotma9l.com hotmai8l.com hotmaijl.com hotmaik.com hotmail.cio.jp hotmail.co.np hotmail.coi.jp hotmail.cop.jp hotmailco.jp hotmailo.com hotmailp.com hotmaiol.com hotmaip.com hotmaipl.com hotmakil.com hotmakl.com hotmali.com hotmaol.com hotmaqil.com hotmauil.com hotmawil.com hotmazil.com hotmil.com hotmjail.com hotmqail.com hotmsil.com hotmzail.com hotmzil.com hotnail.com hotrmail.com htmail.com huotmail.com hyotmail.com i.soffbank.jp i.softbahk.jp i.softbanj.jp i.softbanl.jp i.sotfbank.jp i.sottbank.jp icdloud.com ickoud.com icl9ud.com iclkoud.com iclloud.com icllud.com iclo0ud.com iclo7d.com iclo8d.com iclo8ud.com iclodu.com iclohd.com icloid.com iclojd.com iclolud.com iclooud.com iclopud.com iclou.com icloudd.com icloued.com iclouid.com icloujd.com iclourd.com iclous.com iclouud.com icloux.com iclouyd.com icoloud.com icolud.com icooud.com icpoud.com idcloud.com idloud.com ifcloud.com ifloud.com ifty.com iicloud.com ilcoud.com iloud.com infty.com isoftbank.jp iutlook.com ivcloud.com ivloud.com kcloud.com koutlook.com kutlook.com lutlook.com mail.com mec.om mel.com mobile.ne.jp niffty.com nifry.com nift.com nifth.com niftry.com nifty.co nitty.com nity.com nofty.com o7tlook.com o8tlook.com ocn.lne.jp ocn.ne3.jp ocn.ne4.jp ocn.ned.jp ocn.nje.jp ohtlook.com ojtlook.com okutlook.com olutlook.com ooutlook.com oputlook.com ou5look.com ou6look.com ouflook.com ouglook.com ouitlook.com oulook.com oultook.com ourlook.com ourtlook.com outklook.com outkook.com outl0ok.com outl0ook.com outliok.com outliook.com outlkok.com outllok.com outllok.jp outlo0ok.com outlo9k.com outlo9ok.com outloik.com outlok.jp outlokk.com outloko.com outlokok.com outlolk.com outlolok.com outloo.com outlooi.com outlooik.com outlooj.com outlook.cm outlook.co outlookk.com outlookl.com outlooko.com outlool.com outloolk.com outloom.com outlooo.com outloook.com outloook.jp outlopk.com outlopok.com outlpok.com outolook.jp outook.com outoook.com outplook.com outpook.com outtlook.com outtlook.jp outylook.com ouutlook.com ouylook.com ouytlook.com oytlook.com softbank.lne.jp softbank.ne3.jp softbank.ne4.jp softbank.ned.jp softbank.nje.jp softbankne.jp tgmail.com ucloud.com uotlook.com uotmail.com utlook.com yaboo.co.jp yahoo.cio.jp yahoo.co.np yahoo.coi.jp yahoo.cop.jp yahoo.lne.jp yahoo.ne3.jp yahoo.ne4.jp yahoo.ned.jp yahoo.nje.jp yanoo.ne.jp ybb.lne.jp ybb.ne3.jp ybb.ne4.jp ybb.ned.jp ybb.nje.jp ybbne.jp ygmail.com ymobil.ene.jp ymobile.lne.jp ymobile.ne3.jp ymobile.ne4.jp ymobile.ned.jp ymobile.nje.jp";

  /* 3) ドメインに「.」が無いときの補完(「.」の無いドメインはメールを受け取れない) */
  var BARE = {
    gmail: 'gmail.com', gmai: 'gmail.com', icloud: 'icloud.com', yahoo: 'yahoo.co.jp',
    docomo: 'docomo.ne.jp', ezweb: 'ezweb.ne.jp', hotmail: 'hotmail.com', outlook: 'outlook.com',
    gmailcom: 'gmail.com', icloudcom: 'icloud.com', hotmailcom: 'hotmail.com', outlookcom: 'outlook.com',
    yahoocojp: 'yahoo.co.jp', docomonejp: 'docomo.ne.jp', ezwebnejp: 'ezweb.ne.jp', isoftbankjp: 'i.softbank.jp',
    softbanknejp: 'softbank.ne.jp'
  };

  var KEYS = ['1234567890-', 'qwertyuiop', 'asdfghjkl', 'zxcvbnm'];
  var VALID = /^(?=.{4,})[a-z0-9-]+(\.[a-z0-9-]+)+$/;
  var extra = null;

  function neighbors() {
    var pos = {}, nb = {}, r, c, ch, ch2;
    for (r = 0; r < KEYS.length; r++) for (c = 0; c < KEYS[r].length; c++) pos[KEYS[r][c]] = [r, c];
    for (ch in pos) {
      nb[ch] = [];
      for (ch2 in pos) {
        if (ch2 === ch) continue;
        var a = pos[ch], b = pos[ch2];
        if (Math.abs(a[0] - b[0]) <= 1 && Math.abs((a[1] + 0.5 * a[0]) - (b[1] + 0.5 * b[0])) <= 1.0) nb[ch].push(ch2);
      }
    }
    nb['.'] = ['l'];
    return nb;
  }

  function variants(domain, labelFixed, nb, add) {
    var start = labelFixed ? domain.split('.')[0].length : 0, n = domain.length, i, j, ch, ks;
    for (i = start; i < n; i++) {
      ch = domain.charAt(i);
      add(domain.slice(0, i) + domain.slice(i + 1));
      add(domain.slice(0, i) + ch + domain.slice(i));
      if (i + 1 < n) add(domain.slice(0, i) + domain.charAt(i + 1) + ch + domain.slice(i + 2));
      ks = nb[ch] || [];
      for (j = 0; j < ks.length; j++) {
        add(domain.slice(0, i) + ks[j] + domain.slice(i + 1));
        add(domain.slice(0, i) + ks[j] + domain.slice(i));
        add(domain.slice(0, i + 1) + ks[j] + domain.slice(i + 1));
      }
    }
  }

  /* 追加分の表を作る(初回の判定時に1回だけ。数ミリ秒) */
  function buildExtra() {
    var nb = neighbors(), origin = {}, skip = {}, out = {}, i, v;
    for (i = 0; i < SAFE.length; i++) skip[SAFE[i]] = 1;
    for (i = 0; i < TARGETS.length; i++) skip[TARGETS[i][0]] = 1;
    var ex = EXCLUDE.split(' ');
    for (i = 0; i < ex.length; i++) if (ex[i]) skip[ex[i]] = 1;
    TARGETS.forEach(function (t) {
      variants(t[0], t[1], nb, function (s) {
        if (s === t[0] || !VALID.test(s) || s.indexOf('..') >= 0 || s.slice(-1) === '-') return;
        if (!origin[s]) origin[s] = {};
        origin[s][t[0]] = 1;
      });
    });
    for (v in origin) {
      if (skip[v] || TYPO_DOMAINS[v]) continue;
      var srcs = Object.keys(origin[v]);
      if (srcs.length === 1) out[v] = srcs[0];
    }
    return out;
  }

  /* 打ち間違いなら直した全体のアドレスを返す。違えば null */
  function suggest(value) {
    var m = /^\s*([^@\s]+)@([^@\s]+?)\.*\s*$/.exec(value || '');
    if (!m) return null;
    var domain = m[2].toLowerCase(), fixed = TYPO_DOMAINS[domain];
    if (!fixed) {
      if (!extra) extra = buildExtra();
      fixed = extra[domain] || (domain.indexOf('.') < 0 ? BARE[domain] : null);
    }
    if (!fixed || fixed === domain) return null;
    return { local: m[1], domain: fixed, full: m[1] + '@' + fixed };
  }

  var SKIP_TYPES = /^(password|hidden|checkbox|radio|submit|button|file|image|reset|search|tel|number)$/;
  function isEmailInput(el) {
    if (!el || el.tagName !== 'INPUT' || SKIP_TYPES.test(el.type || '')) return false;
    if (el.closest && el.closest('[data-ws-email-typo="off"]')) return false;
    if (el.type === 'email') return true;
    return /e-?mail/i.test((el.name || '') + ' ' + (el.id || '') + ' ' + (el.getAttribute('autocomplete') || ''));
  }

  function injectCss() {
    if (document.getElementById('ws-email-typo-css')) return;
    var st = document.createElement('style');
    st.id = 'ws-email-typo-css';
    st.textContent =
      '.ws-email-typo{box-sizing:border-box;display:flex;flex-wrap:wrap;align-items:center;gap:4px 8px;' +
      'margin:6px 0 12px;padding:8px 10px 8px 12px;background:#fffaf0;border:1px solid #efdcb4;border-radius:8px;' +
      'font-size:13px;line-height:1.6;color:#4a3f2a;text-align:left;letter-spacing:0;width:100%;max-width:100%}' +
      '.ws-email-typo__msg{flex:1 1 auto;min-width:0;word-break:break-all}' +
      '.ws-email-typo__addr{appearance:none;-webkit-appearance:none;background:none;border:0;padding:0;margin:0;' +
      'font:inherit;font-weight:700;color:#222;text-decoration:underline;text-underline-offset:2px;cursor:pointer;' +
      'word-break:break-all;text-align:left;letter-spacing:0;min-height:0;height:auto;width:auto;text-transform:none}' +
      '.ws-email-typo__addr em{font-style:normal;background:#ffe7a3;border-radius:3px;padding:0 2px}' +
      '.ws-email-typo__fix{appearance:none;-webkit-appearance:none;flex:0 0 auto;background:#222;color:#fff;border:0;' +
      'border-radius:6px;padding:4px 12px;margin:0;font:inherit;font-size:12px;font-weight:700;line-height:1.6;' +
      'cursor:pointer;letter-spacing:0;min-height:0;height:auto;width:auto;text-transform:none}' +
      '.ws-email-typo__fix:hover{opacity:.85}' +
      '.ws-email-typo__close{appearance:none;-webkit-appearance:none;flex:0 0 auto;background:none;border:0;' +
      'padding:0 2px;margin:0;font:inherit;font-size:16px;line-height:1;color:#9a8f7a;cursor:pointer;' +
      'min-height:0;height:auto;width:auto}' +
      '.ws-email-typo--done{background:#f3f8f1;border-color:#cfe3c8;color:#2f5a26}';
    (document.head || document.documentElement).appendChild(st);
  }

  /* 候補を置く場所: 入力欄が横並び(入力欄+ボタン)のグループ内なら、そのグループの直後 */
  function anchorOf(input) {
    var p = input.parentElement;
    if (p && p.tagName !== 'FORM') {
      var cs = window.getComputedStyle(p);
      if ((cs.display.indexOf('flex') >= 0 && cs.flexDirection.indexOf('row') === 0) ||
          cs.display === 'table' || cs.display === 'table-row' || /input-group/.test(p.className || '')) return p;
    }
    return input;
  }

  function hintOf(input) {
    var h = input.__wsTypoHint;
    return h && h.parentNode ? h : null;
  }

  function removeHint(input) {
    var h = hintOf(input);
    if (h) h.parentNode.removeChild(h);
    input.__wsTypoHint = null;
    if (input.getAttribute('aria-describedby') === 'ws-email-typo-' + input.__wsTypoId) input.removeAttribute('aria-describedby');
  }

  function setValue(input, v) {
    var desc = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');
    if (desc && desc.set) desc.set.call(input, v); else input.value = v;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  var seq = 0;
  function showHint(input, s) {
    injectCss();
    var h = hintOf(input);
    if (!h) {
      h = document.createElement('div');
      h.className = 'ws-email-typo';
      h.setAttribute('role', 'status');
      h.setAttribute('aria-live', 'polite');
      if (!input.__wsTypoId) input.__wsTypoId = ++seq;
      h.id = 'ws-email-typo-' + input.__wsTypoId;
      var a = anchorOf(input);
      a.parentNode.insertBefore(h, a.nextSibling);
      /* 入力欄の下余白が大きいテーマなので、その余白を候補の下へ回して欄の直下に付ける */
      var mb = parseFloat(window.getComputedStyle(a).marginBottom) || 0;
      if (mb > 10) { h.style.marginTop = (6 - mb) + 'px'; h.style.marginBottom = mb + 'px'; }
      input.__wsTypoHint = h;
      if (!input.getAttribute('aria-describedby')) input.setAttribute('aria-describedby', h.id);
    }
    h.className = 'ws-email-typo';
    h.innerHTML = '';
    var msg = document.createElement('span');
    msg.className = 'ws-email-typo__msg';
    msg.appendChild(document.createTextNode('もしかして '));
    var addr = document.createElement('button');
    addr.type = 'button';
    addr.className = 'ws-email-typo__addr';
    addr.appendChild(document.createTextNode(s.local + '@'));
    var em = document.createElement('em');
    em.textContent = s.domain;
    addr.appendChild(em);
    msg.appendChild(addr);
    msg.appendChild(document.createTextNode(' ですか?'));
    var fix = document.createElement('button');
    fix.type = 'button';
    fix.className = 'ws-email-typo__fix';
    fix.textContent = '修正する';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ws-email-typo__close';
    close.setAttribute('aria-label', 'このままにする');
    close.title = 'このままにする';
    close.textContent = '×';
    h.appendChild(msg);
    h.appendChild(fix);
    h.appendChild(close);

    function apply(e) {
      e.preventDefault();
      h.className = 'ws-email-typo ws-email-typo--done';  /* 先に「完了」にする(書き換えの input イベントで消されないように) */
      setValue(input, s.full);
      h.innerHTML = '';
      h.appendChild(document.createTextNode('✓ ' + s.full + ' に修正しました'));
      setTimeout(function () { if (input.__wsTypoHint === h) removeHint(input); }, 2500);
      try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
    }
    addr.addEventListener('click', apply);
    fix.addEventListener('click', apply);
    close.addEventListener('click', function (e) {
      e.preventDefault();
      input.__wsTypoDismissed = input.value;
      removeHint(input);
    });
  }

  function check(input) {
    if (input.__wsTypoDismissed && input.__wsTypoDismissed === input.value) return;
    var s = suggest(input.value);
    if (s) showHint(input, s);
    else {
      var h = hintOf(input);
      if (h && h.className.indexOf('--done') < 0) removeHint(input);
    }
  }

  document.addEventListener('focusout', function (e) {
    if (isEmailInput(e.target)) check(e.target);
  }, true);

  /* 入力し直している最中は新しく出さない。出ている候補の更新・取り消しだけ */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (isEmailInput(el) && hintOf(el) && hintOf(el).className.indexOf('--done') < 0) check(el);
  }, true);

  /* 自動入力(オートフィル)は change だけが飛ぶことがある */
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (isEmailInput(el) && document.activeElement !== el) check(el);
  }, true);

  /* 送信時: 判定して候補を出すだけ。送信は止めない */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelectorAll) return;
    var list = form.querySelectorAll('input');
    for (var i = 0; i < list.length; i++) if (isEmailInput(list[i])) check(list[i]);
  }, true);

  /* 検証用(ブラウザのコンソールから) */
  window.wsEmailTypoSuggest = function (v) { var s = suggest(v); return s ? s.full : null; };
  window.wsEmailTypoSuggest.table = function () { if (!extra) extra = buildExtra(); return extra; };
})();
